import { Injectable } from '@angular/core';
import { FrappeApp, FrappeCall } from 'frappe-js-sdk';
import { AppConstant } from '../../app.constant';

@Injectable({
  providedIn: 'root'
})
export class GateInService {

  private frappe: FrappeApp;
    private frappeCall: FrappeCall;
    constructor() {
        this.frappe = new FrappeApp(AppConstant.frappeUrl);
        this.frappeCall = this.frappe.call()
    }

    public getAllGateInData(tokenNo:any):Promise<any>{
        return this.frappeCall.get('vendor_portal.rest.get_all_gate_in_data',{data:JSON.stringify(tokenNo)})
    }

  public getUserDetail(): Promise<any> {
    return this.frappe.call().get('vendor_portal.api.gate_in.get_user_detail');
  }
  public createGateIN(data:any): Promise<any> {
    return this.frappe.call().post('vendor_portal.api.create_gate_in.create_gate',data);
}
}
